import {BaseEntity} from '../../app-common/data/BaseEntity';

export enum SnippetType {
  Web,
  Email,
  Job
}

export class Snippet extends BaseEntity<number> {
  html: string;
  name: string;
  type: SnippetType;
  description: string;
  link: string;
}

